import React from 'react';
import PropTypes from 'prop-types';
import Script from 'next/script';

const getProviders = ({ analytics, deporvillage }) => {
    const providers = [];

    if (analytics) {
        providers.push({
            name: analytics.name,
            config: {
                version: analytics.config.analytics.version,
                code: analytics.config.analytics.code,
                ...(analytics?.config?.ga4?.code ? {
                    ga4: {
                        code: analytics.config.ga4.code,
                        como: analytics.config.ga4.como,
                    },
                } : {}),
                ...(analytics.config.adwords.code ? {
                    adwords: { code: analytics.config.adwords.code },
                } : {}),
                ...(analytics.config.optimize.enabled ? {
                    optimize: { code: analytics.config.optimize.code },
                } : {}),
                ...(analytics.config.tagManager.enabled ? {
                    tag_manager: { code: analytics.config.tagManager.code },
                } : {}),
            },
        });
    }

    if (deporvillage?.config?.enabled) {
        providers.push({
            name: deporvillage.name,
            config: deporvillage.config,
        });
    }

    return {
        type: 'INIT_PROVIDERS',
        name: 'setProviders',
        providers,
    };
};

const getContext = (storeId, breadcrumb) => ({
    type: 'SET',
    name: 'setContext',
    data: {
        storeId,
        device: 'desktop',
        userAgent: navigator.userAgent,
        href: window.location.href,
        navigation: {
            category: breadcrumb && breadcrumb[0]?.name || null,
            subcategory: breadcrumb && breadcrumb[1]?.name || null,
            family: breadcrumb && breadcrumb[2]?.name || null,
        },
    },
});

const TrackingLibrary = ({ bucket, providers, storeId, breadcrumb }) => {
    React.useEffect(() => {
        window.EBus = window.EBus || [];
        window.EBus.push(getProviders(providers));
        window.EBus.push(getContext(storeId, breadcrumb));
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, []);

    return (
        <Script id={'tracking-library'} src={bucket} strategy={'beforeInteractive'} />
    );
};

TrackingLibrary.propTypes = {
    bucket: PropTypes.string,
    providers: PropTypes.object,
    breadcrumb: PropTypes.array,
    storeId: PropTypes.number,
};

export default TrackingLibrary;
